"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _AccountSelectV = require("../../../../components/AccountSelectV2");
var _view = require("../../../../types/view");
var _tracking = require("../../tracking");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AccountSelectContainer = _ref => {
  let {
    view,
    source,
    phone,
    accounts,
    phoneАccounts,
    loadableAccount,
    continueByAccount,
    continueByPhone,
    changeView,
    continueByAccountLoading,
    continueByPhoneLoading
  } = _ref;
  React.useEffect(() => {
    const button = phoneАccounts.length === 0 ? 'create_by_phone' : null;
    (0, _tracking.trackAccountSelectOpen)(source, button);
  }, []);
  const handleSelectAccount = account => {
    if (account) {
      continueByAccount({
        email: account.email,
        phone: account.phone
      });
    } else {
      continueByPhone();
    }
  };
  const handleSwitchToRegistration = React.useCallback(() => {
    changeView(_view.EActiveView.Agreement, {
      prevView: view.active,
      prevData: view.data,
      phone
    });
  }, [changeView, phone, view]);
  return /*#__PURE__*/React.createElement(_AccountSelectV.AccountSelectV2, {
    phone: phone,
    accounts: accounts,
    phoneАccounts: phoneАccounts,
    loadableAccount: loadableAccount,
    continueByPhoneLoading: continueByPhoneLoading,
    continueByAccountLoading: continueByAccountLoading,
    onAccountSelect: handleSelectAccount,
    switchToRegistration: handleSwitchToRegistration
  });
};
exports.AccountSelectContainer = AccountSelectContainer;